/*******************************************************************************
* @ngdoc   service
* @module  bankReconHistory
* @name    bankReconHistory.service:BankReconHistoryService
* @description
* Handles the interaction with the server.
*******************************************************************************/
/* @ngInject */ export function BankReconHistoryService(HTTPService) {
  var http = HTTPService.make('/books/bankReconHistory/');

  this.drop = function (id) {
    return http.get(`drop/${id}`);
  };
  this.get = function (id) {
    return http.get(`get/${id}`);
  };
  this.getDefaultBank = function () {
    return http.get('getDefaultBank');
  };
  this.viewList = function () {
    return http.get('viewList');
  };
};
